export const maxWidth = '680px';
